import React from 'react';

const FORMSPREE = 'https://formspree.io/f/mnpjkvwy';

// Catches render errors anywhere below it and reports them once to Formspree,
// so a breakage emails you instead of silently showing a blank page.
class ErrorReporter extends React.Component {
    constructor(props) {
        super(props);
        this.state = { crashed: false };
    }

    static getDerivedStateFromError() {
        return { crashed: true };
    }

    componentDidCatch(error, info) {
        // Fire-and-forget; never let the reporter itself throw.
        try {
            fetch(FORMSPREE, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                    subject: 'Portfolio site error',
                    message: String(error && error.stack ? error.stack : error),
                    componentStack: info && info.componentStack,
                    url: window.location.href,
                    userAgent: navigator.userAgent,
                }),
            }).catch(() => {});
        } catch (_) { /* ignore */ }
    }

    render() {
        if (this.state.crashed) {
            return (
                <div className="container" style={{ padding: '4rem 0', textAlign: 'center' }}>
                    <p>Something went wrong. Please reload the page.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorReporter;
